import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/HomePage.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import(/* webpackChunkName: "blog" */ './views/Blog.vue')
  },
  {
    path: '/produits',
    name: 'catalogue',
    component: () => import(/* webpackChunkName: "catalogue" */ './views/CataloguePage.vue'),
    props: true
  },
  {
    path: '/produits/:id',
    name: 'produits',
    component: () => import(/* webpackChunkName: "produits" */ './views/ProduitsPage.vue'),
    props: true
  },
  {
    path: '/category/:id',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ './views/CategoryPage.vue'),
    props: true
  },
  {
    path: '/thenks/:id',
    name: 'thenks',
    component: () => import(/* webpackChunkName: "thenks" */ './views/ThenksPage.vue'),
    props: true
  },
  {
    path: '/fail/:id',
    name: 'fail',
    component: () => import(/* webpackChunkName: "fail" */ './views/FailPage.vue'),
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
